<template>
    <div>
        <div style="font-size: 14px">
            <div>
                <span style="display: inline-block; width: 160px;"><i class="el-icon-warning-outline"></i>
                    低于该版本需要强更：</span>
                <span style="color: #606266">{{
                    minVersion == ""
                    ? "<未设置>"
                    : minVersion
                }}</span>
            </div>
            <div style="margin-top: 5px">
                <span style="display: inline-block; width: 160px;"><i class="el-icon-mouse"></i>
                    强更跳转链接：</span>
                <span style="color: #606266">{{
                    url == ""
                    ? "<未设置>"
                    : url
                }}</span>
            </div>
        </div>
        <el-button style="margin-top: 30px" type="primary" icon="el-icon-setting"
            @click="openEditForceUpdateConfigDialog()">设置</el-button>
    </div>
</template>

<script>
const axios = require("axios");
import util from "@/util";
import bizutil from "@/bizutil";
const dialogutil = require("@/dialogutil");

export default {
    data() {
        return {
            minVersion: "",// 强更版本号
            url: "", // 强更跳转链接
        }
    },

    async created() {
        await this.loadDataFromServer();
    },

    methods: {
        async loadDataFromServer() {
            let resData = (
                await axios.post(
                    `${util.getBackendApiBase()}/api/admin/v1/forceUpdate/getForceUpdateConfig`,
                    {},
                    {
                        headers: {
                            token: bizutil.getLoginUserToken(),
                        },
                    }
                )
            ).data;
            if (resData.code > 0) {
                this.$message.error(resData.message);
                return;
            }

            this.minVersion = resData.data.minVersion;
            this.url = resData.data.url;
        },

        openEditForceUpdateConfigDialog() {
            dialogutil.open("EditForceUpdateConfigDialog", {
                closedCallback: () => {
                    this.loadDataFromServer();
                },
                data: {
                    minVersion: this.minVersion,
                    url: this.url,
                },
            });
        },
    }
}
</script>